import { Component, type ErrorInfo, type ReactNode } from "react";
import { Button } from "../components/ui";
export class ErrorBoundary extends Component<
  { children: ReactNode },
  { failed: boolean }
> {
  state = { failed: false };
  static getDerivedStateFromError() {
    return { failed: true };
  }
  componentDidCatch(error: Error, info: ErrorInfo) {
    console.error("EmpreitaFlow UI error", error, info);
  }
  render() {
    if (this.state.failed)
      return (
        <main className="fatal-error">
          <div>
            <span>Fluxo interrompido</span>
            <h1>Algo saiu fora do fluxo.</h1>
            <p>
              Tente recarregar a página. Seus dados locais permanecem salvos
              neste navegador.
            </p>
            <Button onClick={() => window.location.reload()}>
              Recarregar página
            </Button>
          </div>
        </main>
      );
    return this.props.children;
  }
}
